// extracted by mini-css-extract-plugin
export default {"Box":"repo-list-module__Box--Lb3lV","Text":"repo-list-module__Text--PK2_q"};